import axios from 'axios';
import store from '../store';
import verifyAuth from '../services/utilities' 

class BrokerAccountRepository {

    constructor(){
        this.basePath = store.state.backend;
    }

    createBrokerAccount(brokerAccount) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/broker-accounts`, brokerAccount,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    updateBrokerAccount(brokerAccount) {
        let headers = {'Authorization': store.state.token};
        let response = axios.put(`${this.basePath}/broker-accounts`, brokerAccount, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    deleteBrokerAccount(brokerAccountId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.delete(`${this.basePath}/broker-accounts/${brokerAccountId}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    allBrokerAccountsOfUser() {
        let headers = {'Authorization': store.state.token};
        let url = (store.state.whitelabel !== null && store.state.whitelabel.partner !== null)?
            `${this.basePath}/ext/broker-accounts/user/by-partner?partnerId=${store.state.whitelabel.partner.id}` :
            `${this.basePath}/ext/broker-accounts/user`;
        let response = axios.get(url, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    allBrokerAccountsOfExternalUser(userId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/broker-accounts/user/external?userId=${userId}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    verifyBrokerAccount(accountId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/broker-accounts/verify?accountId=${accountId}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }
}

export default new BrokerAccountRepository();
